import React from 'react';

const StatusTabs = ({ activeTab, counts, onTabChange }) => {
  const tabs = [
    { key: 'all', label: 'All', count: counts.all },
    { key: 'publish', label: 'Published', count: counts.published },
    { key: 'draft', label: 'Draft', count: counts.draft },
  ];

  return (
    <div className="mb-6">
      <nav className="flex -mb-px gap-1">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`
              py-3 px-6 text-sm font-medium transition-colors cursor-pointer
              ${
                activeTab === tab.key
                  ? 'bg-[#F4F4F5] px-3 py-[6px] text-[#6F6F7B] rounded-xl'
                  : 'text-[#6F6F7B]'
              }
            `}
          >
            {tab.label}
            <span
              className={`
                ml-2 py-0.5 px-2 rounded-full text-xs font-semibold
                ${
                  activeTab === tab.key
                    ? 'bg-[#7C3BED]/10 text-[#7C3BED]'
                    : 'bg-gray-100 text-[#6F6F7B]'
                }
              `}
            >
              {tab.count}
            </span>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default StatusTabs;